/**
 * «🆕 Новые за сутки» — `#newBlock` (ui-blocks.md §7.2).
 *
 * Дела, созданные за последние 24 часа (признака «просмотрено» в системе нет,
 * DECISIONS.md). Пустое состояние особое: блок скрывается целиком,
 * никакой заглушки не выводится.
 */

import type { KeyboardEvent } from 'react';
import { BLOCK_GAP, HEAD_NOTE, caseWord, deadlineClass } from './format';
import type { NewTodayBlock, OpenCase } from './types';

interface Props {
    newToday: NewTodayBlock;
    openCase: OpenCase;
}

export function NewToday({ newToday, openCase }: Props) {
    if (newToday.rows.length === 0) return null;

    // В заголовке стоит настоящий счётчик, а строк приходит не больше двадцати.
    const rest = newToday.count - newToday.rows.length;

    const onKeyDown = (event: KeyboardEvent<HTMLDivElement>, id: string): void => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openCase(id);
    };

    return (
        <div className="stat-block" id="newBlock" style={BLOCK_GAP}>
            <div className="block-header">
                <span>
                    🆕 Новые за сутки{' '}
                    <span id="newCount" style={HEAD_NOTE}>
                        · {newToday.count}
                    </span>
                </span>
            </div>
            <div className="block-body" id="newList">
                {newToday.rows.map((item) => (
                    <div
                        key={item.case_id}
                        className="decision-row"
                        data-case={item.case_id}
                        role="button"
                        tabIndex={0}
                        onClick={() => openCase(item.case_id)}
                        onKeyDown={(event) => onKeyDown(event, item.case_id)}
                    >
                        <span className="dr-reason approval">новое</span>
                        <span className="dr-id">{item.number}</span>
                        <span className="dr-title">
                            {item.title}
                            {item.escalation_risk ? ' 🛡' : ''}
                        </span>
                        <span className="dr-exec">{item.applicant ?? '—'}</span>
                        <span className={`dr-date ${deadlineClass(item.deadline_state)}`.trim()}>
                            {item.deadline_text}
                        </span>
                    </div>
                ))}
                {rest > 0 && (
                    <div className="case-more">
                        и ещё {rest} {caseWord(rest)}
                    </div>
                )}
            </div>
        </div>
    );
}
